import Image from 'components/image'
// eslint-disable-next-line import/no-extraneous-dependencies
import { IconButton, Textarea } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { EditPencil } from 'baby-design/icons'

import { RegItem } from 'src/types/regItem'
import NiceModal from '@ebay/nice-modal-react'
import { CategoryDropdown } from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/CategoryDropdown'
import { getCategoriesAsKeyValue } from 'src/routes/(registry)/list/[slug]/utils/productHelpers'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import { useQuery } from '@tanstack/react-query'
import { Registry } from 'src/types/registry'
import { FETCH_REGISTRY_KEY, fetchRegistry } from 'src/api/queries'
import {
  CrowdfundFieldsProps,
  CrowdfundFormProps,
} from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/fields/RegItemFields.types'
import CrowdfundContributionsSection from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/fields/CrowdfundFields/components/CrowdfundContributionsSection/CrowdfundContributionsSection'
import EditItemDetailsPrivateItemSetting from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/PrivateItem/PrivateItem'
import EditRegItemDrawer from '../EditRegItemDrawer'
import CashFundPreferencesDrawer from '../../CashFundPreferencesDrawer/CashFundPreferencesDrawer'
import ProductInfoDrawer from '../../ProductInfoDrawer/ProductInfoDrawer'
import { EditItemDetailsCashFundPreferences } from '../components/CashFundPreferences'
import css from './fields.style.scss'
import { EditItemDetailsFavoriteSetting } from '../components/Favorite'

export function CrowdfundForm({
  purchasable = false,
  regItemFields,
  registry,
  updateRegItemFields,
  handleDelete,
  reservations,
  onEditProductInfo,
  onEditCashFundPreferences,
  onRegItemUpdated,
}: CrowdfundFormProps) {
  const { categories } = registry || {}
  const categoriesAsKeyValue = getCategoriesAsKeyValue(categories || [])
  return (
    <div className={css.fields}>
      <div className={css.fields__item_intro}>
        <Image
          alt={regItemFields.title}
          className={css.fields__item_intro_img}
          src={regItemFields.imgUrl}
        />
        <div className={css.fields__item_intro_info}>
          <div className={css.fields__item_title}>{regItemFields.title}</div>
        </div>
        <IconButton
          className={css.fields__image_edit}
          size="sm"
          variant="fill-inverted"
          onClick={onEditProductInfo}
        >
          <EditPencil />
        </IconButton>
      </div>
      <div className={css.fields__item_details}>
        <CategoryDropdown
          categories={categoriesAsKeyValue}
          regItemFields={regItemFields}
          updateRegItemFields={updateRegItemFields}
        />
        <div className={css.fields__item_input}>
          <Textarea
            label="Notes to friends and family "
            placeholder="Add a note..."
            size="md"
            value={regItemFields.description || undefined}
            onChange={(e) =>
              updateRegItemFields({ description: e.target.value })
            }
          />
        </div>
        {purchasable && (
          <CrowdfundContributionsSection
            regItem={regItemFields}
            reservations={reservations}
            onRegItemUpdated={(updates) => onRegItemUpdated?.(updates)}
          />
        )}
        <EditItemDetailsFavoriteSetting
          regItemFields={regItemFields}
          updateRegItemFields={updateRegItemFields}
        />
        <EditItemDetailsPrivateItemSetting
          categories={categoriesAsKeyValue}
          regItemFields={regItemFields}
          updateRegItemFields={updateRegItemFields}
        />
        <EditItemDetailsCashFundPreferences
          openCashFundPreferencesDrawer={onEditCashFundPreferences}
          registry={registry}
        />
      </div>
      {handleDelete && (
        <>
          <div className={css.fields__divider} />
          <div className={css.fields__item_delete}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <a className={css.fields__delete_link} onClick={handleDelete}>
              Delete item
            </a>
          </div>
        </>
      )}
    </div>
  )
}

export const CrowdfundFields = (props: CrowdfundFieldsProps) => {
  const [currentUser] = useCurrentUser()

  const registryId = currentUser?.currentRegistry?.id

  const { data: registry, refetch } = useQuery<Registry>({
    enabled: !!registryId,
    queryKey: [FETCH_REGISTRY_KEY, registryId],
    queryFn: () => fetchRegistry(registryId),
  })

  const { regItem } = props
  const openProductInfoDrawer = async () => {
    const response: RegItem | undefined = await NiceModal.show(
      ProductInfoDrawer,
      { regItem }
    )
    if (response) {
      NiceModal.show(EditRegItemDrawer, { regItem: response })
    }
  }

  const openCashFundPreferencesDrawer = async () => {
    const response = await NiceModal.show(CashFundPreferencesDrawer)
    if (response) {
      refetch()
    }
  }

  return (
    <CrowdfundForm
      {...props}
      purchasable
      registry={registry}
      onEditCashFundPreferences={openCashFundPreferencesDrawer}
      onEditProductInfo={openProductInfoDrawer}
    />
  )
}
